import { createSelector } from "@reduxjs/toolkit";

import { type FeatureKey } from "@ds/modules/features/@types";

import { type RootState } from "@ds/store/bootstrap";

import { LoadStatus } from "@ds/utils/reducer";

import { FeaturesRemoteOperation } from "./slice";

const selectBaseState = (state: RootState) => state.features;

const selectLoadStatus = (state: RootState, operation = FeaturesRemoteOperation.FETCH) =>
  selectBaseState(state).loadStatusMap[operation];

export const selectFeaturesIsLoading = (state: RootState, operation = FeaturesRemoteOperation.FETCH) =>
  selectLoadStatus(state, operation) === LoadStatus.Loading;

export const selectFeaturesIsSucceeded = (state: RootState, operation = FeaturesRemoteOperation.FETCH) =>
  selectLoadStatus(state, operation) === LoadStatus.Succeeded;

export const selectFeaturesByProjectId = (state: RootState, projectId: number) =>
  selectBaseState(state).byProjectId[projectId] ?? [];

export const selectFeaturesError = (state: RootState) => selectBaseState(state).error;

export const selectFeatureByKey = createSelector(
  [selectFeaturesByProjectId, (_state: RootState, _projectId: number, featureKey: FeatureKey) => featureKey],
  (features, featureKey) => features.find(f => f.feature_key === featureKey),
);
